export default __webpack_public_path__ + "static/vidazoo-17f41eb5544c098a123b60c2737b44a3.svg";